import { createContext, useContext } from 'react';

/**
 * What the header's language picker needs to know while a module is open.
 *
 * A topic's UID is per language, so switching language inside a module used to
 * mean going back to the journey — there was no way to name the same module in
 * the language just chosen. The module route knows: it loaded every topic to
 * work out the journey order, so it can hand down the UID of this module's
 * topic in each language it exists in, and the sheet navigates to it.
 *
 * `null` — the default — means "not inside a module", which is every other
 * screen the header renders on, and the sheet behaves as it always has.
 */
export type ModuleTopicUids = Readonly<Record<string, string>>;

export const ModuleTopicUidsContext = createContext<ModuleTopicUids | null>(null);

const EMPTY: ModuleTopicUids = {};

/**
 * The open module's topic UIDs by language, or an empty map on every screen
 * that is not a module — so a caller can look a language up unconditionally.
 */
export function useModuleTopicUids(): ModuleTopicUids {
  return useContext(ModuleTopicUidsContext) ?? EMPTY;
}
